import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import Button from "../../components/ui/button";
import { LeadFormDialog } from "./LeadFormDialog";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const testimonials = [
  {
    name: "Mohamed",
    city: "Cairo",
    quote: "Weighing machine integration saved me hours daily.",
    rating: 5,
  },
  {
    name: "Nour",
    city: "Cairo",
    quote: "Customer credit tracking keeps my regulars happy.",
    rating: 5,
  },
  {
    name: "Omar",
    city: "Alexandria",
    quote: "Barcode scanning made checkout so much faster.",
    rating: 5,
  },
];

export const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const { t } = useTranslation();
  // Auto-advance testimonials every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <section className="py-8 md:py-12 bg-background">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
          {t("Trusted by")}{" "}
          <span className="text-primary">{t("1000+ Stores")}</span>{" "}
          {t("Across Egypt")}
        </h2>
        <p className="text-center text-muted-foreground mb-8 md:mb-12 text-base md:text-lg">
          {t("Real retailers, real results")}
        </p>

        {/* <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-card p-8 rounded-2xl shadow-[var(--shadow-medium)] border border-border hover:scale-105 transition-transform duration-300"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 text-yellow-400 fill-yellow-400"
                  />
                ))}
              </div>
              <p className="text-foreground text-lg mb-4 italic">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-border pt-4">
                <p className="font-semibold text-foreground">
                  {testimonial.name}
                </p>
                <p className="text-muted-foreground text-sm">
                  {testimonial.city}
                </p>
              </div>
            </div>
          ))}
        </div> */}

        <div className="max-w-6xl mx-auto relative">
          {/* Navigation Arrows */}
          <Button
            variant="outline"
            size="icon"
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-background border-border hover:bg-muted"
            onClick={prevTestimonial}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>

          <Button
            variant="outline"
            size="icon"
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-background border-border hover:bg-muted"
            onClick={nextTestimonial}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>

          {/* Three Testimonials Grid */}
          <div className="mx-4 md:mx-12">
            {/* On Desktop: Show 3 testimonials */}
            <div className="hidden md:grid md:grid-cols-3 gap-6">
              {[0, 1, 2].map((offset) => {
                const testimonialIndex =
                  (currentTestimonial + offset) % testimonials.length;
                const testimonial = testimonials[testimonialIndex];

                return (
                  <div
                    // key={index}
                    className="bg-card p-8 rounded-2xl shadow-[var(--shadow-medium)] border border-border hover:scale-105 transition-transform duration-300"
                  >
                    <div className="flex gap-1 mb-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star
                          key={i}
                          className="w-5 h-5 text-yellow-400 fill-yellow-400"
                        />
                      ))}
                    </div>
                    <p className="text-foreground text-lg mb-4 italic">
                      "{t(testimonial.quote)}"
                    </p>
                    <div className="border-t border-border pt-4">
                      <p className="font-semibold text-foreground">
                        {t(testimonial.name)}
                      </p>
                      <p className="text-muted-foreground text-sm">
                        {t(testimonial.city)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* On Mobile: Show only 1 testimonial */}
            <div className="block md:hidden">
              {(() => {
                const testimonial =
                  testimonials[currentTestimonial % testimonials.length];
                return (
                  <div
                    // key={index}
                    className="bg-card p-8 rounded-2xl shadow-[var(--shadow-medium)] border border-border hover:scale-105 transition-transform duration-300"
                  >
                    <div className="flex gap-1 mb-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star
                          key={i}
                          className="w-5 h-5 text-yellow-400 fill-yellow-400"
                        />
                      ))}
                    </div>
                    <p className="text-foreground text-lg mb-4 italic">
                      "{t(testimonial.quote)}"
                    </p>
                    <div className="border-t border-border pt-4">
                      <p className="font-semibold text-foreground">
                        {t(testimonial.name)}
                      </p>
                      <p className="text-muted-foreground text-sm">
                        {t(testimonial.city)}
                      </p>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>

        <div className="text-center pt-6">
          <p className="text-base sm:text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">
            {t("You could be the next success story. Fill the form today!")}
          </p>
          <LeadFormDialog>
            <Button className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 md:px-8 py-4 md:py-6 text-base md:text-lg">
              {t("Join These Happy Retailers")}
            </Button>
          </LeadFormDialog>
        </div>
      </div>
    </section>
  );
};
